import { createSlice } from "@reduxjs/toolkit";
import { europeLeaseProjectDetail } from "../../Authorizations/interfaces/Interfaces";

interface InitialState {
    data: europeLeaseProjectDetail,
    error: string,
    loading: boolean
}

const initialState: InitialState =
{
    data: {} as europeLeaseProjectDetail,
    error: '',
    loading: false
}

const europeLeaseProjectDetailSlice = createSlice(
    {
        name: 'europeLeaseProjectDetail',
        initialState,
        reducers: {
            resetState: (state) => {
                state.data = {} as europeLeaseProjectDetail;
                state.error = "";
                state.loading = false;
            },
            updateEuropeLeaseProjectDetail(state, action) {
                state.data = action.payload;
            }
        },

    }
);
export const { updateEuropeLeaseProjectDetail, resetState: resetEuropeLeaseProjectDetailStateAction } = europeLeaseProjectDetailSlice.actions;
export default europeLeaseProjectDetailSlice.reducer;
